import React, {useState} from 'react';
import styled, {css, keyframes} from "styled-components";
import {colors} from "../../maps/colors";
import IconBtn from "../IconBtn";
import ALERT_MAP from "../../maps/alertMap";
import SensorWithPlacements from "./SensorWithPlacements";
import {Link} from "react-router-dom";
import SensorDialog from "./SensorDialog";

const SensorWrapperStyled = styled.div`
    display: inline-block;
    margin: 10px;
`;

const AlertsGridWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 8px);
    grid-gap: 15px;
`;

const IconWrapperStyled = styled.div`

`;

const SensorActionsStyled = styled.div`
    margin-top: 1px;
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr 1fr;
    align-items: center;

    svg {
        width: 15px;
        height: 15px;
    }
`;

const AlertListStyled = styled.div`
    cursor: pointer;
`;

const SettingsFromStyled = styled.div`
    span {
        font-size: 11px;
        font-weight: bold;
    }

    .oofk {
        font-weight: 300;
        width: max-content;
        font-size: 10px;
        color: rgb(108, 121, 135);
    }
`;

const blinker = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const AlertItemStyled = styled.div`
    font-size: 11px;
    text-align: center;
    color: ${colors.WHITE};

    &.INFO {
        background: ${colors.LIGHT_GREEN};
    }

    &.CRITICAL {
        background: ${colors.WARM_RED};
    }

    &.WARNING {
        background: ${colors.LIGHT_ORANGE};
    }

    &.blink {
        animation: ${blinker} 2s linear infinite;
    }

    ${({blinking}) => blinking && css`
        animation: ${blinker} 2s linear infinite;
    `}
`;

const Sensor = ({data, sensor, openAlerts, openSettingsHandle, field, site}) => {
    if (!sensor) return null;

    const [sDialog, s_sDialog] = useState(false);

    const alerts = sensor?.alerts;
    const haveAlerts = sensor?.alerts?.length > 0;

    let alertSettings = data?.alertSettings;
    const siteSettings = site?.alertSettings;
    const fieldSettings = field?.alertSettings;
    let settingsFrom = null;

    if (siteSettings) {
        alertSettings = siteSettings;
        settingsFrom = 'Site';
    }
    if (fieldSettings) {
        alertSettings = fieldSettings;
        settingsFrom = 'Field';
    }
    if (data?.alertSettings) {
        alertSettings = data?.alertSettings;
        settingsFrom = 'Sensor';
    }
    if (!alertSettings) {
        alertSettings = {};
        settingsFrom = 'Default';
    }

    return (<SensorWrapperStyled>
        {haveAlerts && (<AlertListStyled
            onClick={openAlerts}
        >
            {alerts.map((item, idx) => {
                const classes = `blink ${item.severity}`;

                return (<Link
                    to={`/im-alerts?type=${item.eventSubType}&eventId=${item._id}`}
                    key={idx}
                    style={{textDecoration: "none"}}
                >
                    <AlertItemStyled
                        className={classes}
                        style={{}}
                    >
                        {ALERT_MAP.eventTypes[item.eventSubType]?.title}
                    </AlertItemStyled>
                </Link>);
            })}
        </AlertListStyled>)}
        <SensorWithPlacements
            sensor={sensor}
            placements={sensor?.placements}
        />
        <SensorActionsStyled>
            <AlertsGridWrapperStyled
                onClick={openSettingsHandle}
            >
                {ALERT_MAP.values.map((item, idx) => {
                    if (item.code === 'low_inventory') {
                        return null;
                    }
                    let isEnabled = true;
                    if (alertSettings?.[item.code]) {
                        isEnabled = alertSettings?.[item.code]?.isEnabled;
                    }

                    return (<IconWrapperStyled key={idx}>
                        <IconBtn
                            onClick={() => {

                            }}
                            customtheme="custom"
                            style={{
                                cursor: 'pointer',
                                width: 18,
                                height: 18,
                                background: isEnabled ? colors.SUCCESS_GREEN : colors.LIGHT_GRAY,
                                color: isEnabled ? colors.WHITE : colors.BLACK_LIGHT
                            }}
                            size="small">
                            {item.icon}
                        </IconBtn>
                    </IconWrapperStyled>);
                })}
            </AlertsGridWrapperStyled>
            {settingsFrom && (<SettingsFromStyled>
                <span className="oofk">S from:</span>
                <span>{settingsFrom}</span>
            </SettingsFromStyled>)}
            <IconBtn size="small"
                     style={{ cursor: 'pointer', width: 16, height: 16 }}
                     title="Add"
                     onClick={() => s_sDialog(true)}>add</IconBtn>
        </SensorActionsStyled>
        {sDialog && (<SensorDialog
            sensor={sensor}
            onClose={() => s_sDialog(false)}
        />)}
    </SensorWrapperStyled>);
};

export default Sensor;